import Heatshrink from './heatshrink';

export default Heatshrink;
